import { TaskFormContextProvider, useModalContext } from "../../../providers";

import { Task } from "../../../types/task";

import TaskForm from "../../Forms/Task/FormTask/FormTask";

import ModalContainer from "../ModalContainer";

const CreateTaskModal = ({
  addTask,
}: {
  addTask: (task: Task) => void;
}) => {
  const { modalOpen, closeModal } = useModalContext();

  return (
    <ModalContainer
      destroyOnClose
      open={modalOpen === "createTask"}
      onCancel={closeModal}
    >
      <TaskFormContextProvider>
        <TaskForm
          addTask={addTask}
        />
      </TaskFormContextProvider>
    </ModalContainer>
  );
};
export default CreateTaskModal;
